import { Box } from '@chakra-ui/react';
import { specialFont, verdanaFont } from 'constants/theme';
import { Button, ButtonProps, Icon } from 'components/UI';
import { FaCaretLeft, FaCaretRight } from 'react-icons/fa';

type SideMenuToggleProps = ButtonProps & {
  onToggleSideMenu(): void;
  title?: string;
  closed: boolean;
};

const SideMenuToggle = ({ onToggleSideMenu, title, closed, ...props }: SideMenuToggleProps) => (
  <Button
    display="flex"
    flex={1}
    cursor="pointer"
    fontFamily={verdanaFont}
    flexDir="column"
    alignSelf="stretch"
    pt={0}
    maxW={5}
    borderRadius={0}
    minW={0}
    justifyContent="flex-start"
    onClick={onToggleSideMenu}
    aria-label="Collapse/Expand Menu"
    {...props}
  >
    <Icon as={closed ? FaCaretRight : FaCaretLeft} mt={2} fontSize="md" />
    <Box
      sx={{ writingMode: 'vertical-lr', fontSize: 'sm', mt: 2, fontFamily: specialFont, textTransform: 'uppercase' }}
    >
      {title}
    </Box>
  </Button>
);

export default SideMenuToggle;
